import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;

const removeQueryString = (url?: string): string | undefined => {
  if (!url) return url;
  return url.split('?')[0];
};

if (dsn) {
  Sentry.init({
    dsn,
    environment:
      process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: {
        request: false,
        response: false,
      },
      queryParams: false,
      httpBodies: [],
    },
    beforeSend(event: Sentry.ErrorEvent) {
      delete event.user;

      if (event.request) {
        event.request.url = removeQueryString(event.request.url);
        delete event.request.cookies;
        delete event.request.data;
        delete event.request.headers;
        delete event.request.query_string;
      }

      return event;
    },
    beforeBreadcrumb(breadcrumb: Sentry.Breadcrumb) {
      if (
        breadcrumb.category === 'fetch' ||
        breadcrumb.category === 'xhr' ||
        breadcrumb.category === 'navigation'
      ) {
        breadcrumb.data = {
          ...breadcrumb.data,
          from: removeQueryString(breadcrumb.data?.from),
          to: removeQueryString(breadcrumb.data?.to),
          url: removeQueryString(breadcrumb.data?.url),
        };
      }

      return breadcrumb;
    },
  });
}
